import React from 'react';
import MuiBox from '@material-ui/core/Box';

const Box = (props) => {
  return <MuiBox {...props} />;
};

export default Box;
